import { gql } from '@apollo/client';

const GET_USER_PROFILE = gql`
  query getUserProfile($id: ID!) {
    userProfile(id: $id) {
      id
      fullname
      username
      email
      link
      role
      following {
        id
        fullname
        username
      }
      followers {
        id
        fullname
        username
      }
      profileImg
      coverImg
      createdAt
    }
  }
`;

const GET_USERS = gql`
  query getUsers {
    users {
      id
      fullname
      username
      email
      link
      role
      following {
        id
        fullname
        username
      }
      followers {
        id
        fullname
        username
      }
      profileImg
      coverImg
      createdAt
    }
  }
`;

const GET_FOLLOWING = gql`
  query getFollowing($id: ID!) {
    following(id: $id) {
      id
      fullname
      username
    }
  }
`;

const GET_FOLLOWERS = gql`
  query getFollowers($id: ID!) {
    followers(id: $id) {
      id
      fullname
      username
    }
  }
`;

const GET_SUGGESTED_USERS = gql`
  query getSuggestedUsers($id: ID!) {
    suggestedUsers(id: $id) {
      id
      fullname
      username
      email
      link
      role
      following {
        id
        fullname
        username
      }
      followers {
        id
        fullname
        username
      }
      profileImg
      coverImg
      createdAt
    }
  }
`;

export { GET_USER_PROFILE, GET_SUGGESTED_USERS, GET_USERS, GET_FOLLOWING, GET_FOLLOWERS }
